module.exports = __webpack_public_path__ + "img/logo-management.d3e8bd8c.png";